import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CPUBenchmarkItem } from '@models/domain/cpu.benchmark.item';
import { AddCPUBenchmarkRequest } from '@models/ss-api/requests/add.cpu.benchmark.request';
import { UpdateCPUBenchmarkRequest } from '@models/ss-api/requests/update.cpu.benchmark.request';

export interface IUpdateCPUBenchmarkTemplate {
    Title: string;
    CPUBenchmark?: CPUBenchmarkItem;
}

@Component({
    selector: 'update-cpubenchmark-dialog',
    styleUrls: ['./update.cpubenchmark.dialog.scss'],
    templateUrl: './update.cpubenchmark.dialog.html'
})

export class UpdateCPUBenchmarkDialog extends DialogComponent<IUpdateCPUBenchmarkTemplate, boolean> implements IUpdateCPUBenchmarkTemplate, OnInit {
    IsBusy: boolean;
    Title: string;
    CPUBenchmark: CPUBenchmarkItem;

    CPUBenchmarkForm: FormGroup;

    constructor(private api: ssApiService, dialogService: DialogService, private gb: GlobalService, private sweetAlert: SweetAlertService, public router: Router) {
        super(dialogService, router);
    }

    ngOnInit() {
        this.IsBusy = false;
        if (!this.CPUBenchmark) {
            this.CPUBenchmark = new CPUBenchmarkItem();
        } else {

        }

        this.CPUBenchmarkForm = new FormGroup({
            'CPUName': new FormControl(this.CPUBenchmark.CPUName, [Validators.required]),
            'BenchmarkScore': new FormControl(this.CPUBenchmark.BenchmarkScore, [Validators.required, Validators.maxLength(7), Validators.minLength(1), Validators.pattern('^-?[0-9 \]+$')])
        })
    }

    confirm() {
        if (!this.CPUBenchmarkForm.valid) return false;
        this.IsBusy = true;
        this.result = true;

        let controls = this.CPUBenchmarkForm.controls;

        if (!this.CPUBenchmark.CPUBenchmarkID) {
            let request: AddCPUBenchmarkRequest = {
                CPUName : controls['CPUName'].value,
                BenchmarkScore: controls['BenchmarkScore'].value
            }

            let disposable = this.api.AddCPUBenchmark(request).subscribe(response => {
                if (response.Result) {
                    this.sweetAlert.swal({
                        type: 'success',
                        title: 'Success!',
                        timer: 1500
                    }).then( () => { this.close(); }, () => { this.close(); } )
                }
                disposable.unsubscribe();
            })
        } else {
            let request: UpdateCPUBenchmarkRequest = {
                CPUBenchmarkID: this.CPUBenchmark.CPUBenchmarkID,
                NewBenchmarkScore: controls['BenchmarkScore'].value
            }

            let disposable = this.api.UpdateCPUBenchmark(request).subscribe(response => {
                if (response.Result) {
                    this.sweetAlert.swal({
                        type: 'success',
                        title: 'Success!',
                        timer: 1500
                    }).then( () => { this.close(); }, () => { this.close(); } )
                }
                disposable.unsubscribe();
            })
        }
    }

}
